// ══════════════════════════════════════════════════════════════════════════════════════════════
//  «CÓMO SE HACE»: ¿QUÉ VÍDEOS TIENE LA PANTALLA QUE SE ESTÁ MIRANDO?                          (t578 · 30-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El mapa (pantalla → lecciones) es un DATO del servidor (el catálogo de la Formación, por GET
//  /api/formacion/como-se-hace); aquí solo se decide cuáles casan con la dirección de ahora. El botón lo pinta
//  components/ComoSeHace.jsx en la cabecera; ninguna pantalla lleva el suyo escrito.
//
//  EL PATRÓN: '/ruta/:param?clave=valor&otra=*&nada='. `:x` es cualquier tramo (no vacío); `clave=valor`, ese valor;
//  `clave=*`, que esté con cualquier valor; `clave=` (vacío), que NO esté. Antes de mirar, `por_defecto` rellena lo que la
//  dirección no lleva (/seguimiento sin ?t= es Recordatorios). Casan todos los que casen y sus lecciones se juntan, sin
//  repetir, las del patrón más concreto primero.
//
//  PURO: sin React y sin imports (lo cargan de verdad las guardias). Lo mide backend/routes/como-se-hace.test.js.

function partir(patron) {
  const s = String(patron || '')
  const i = s.indexOf('?')
  const camino = i < 0 ? s : s.slice(0, i)
  const consulta = i < 0 ? '' : s.slice(i + 1)
  const tramos = camino.split('/').filter(Boolean)
  const condiciones = consulta ? consulta.split('&').filter(Boolean).map((p) => {
    const j = p.indexOf('=')
    return j < 0 ? [p, '*'] : [p.slice(0, j), p.slice(j + 1)]
  }) : []
  return { tramos, condiciones }
}

function leerConsulta(busqueda) {
  const m = new Map()
  const s = String(busqueda || '').replace(/^\?/, '')
  if (!s) return m
  for (const par of s.split('&')) {
    if (!par) continue
    const j = par.indexOf('=')
    const dec = (x) => { try { return decodeURIComponent(x.replace(/\+/g, ' ')) } catch (_) { return x } }
    const k = dec(j < 0 ? par : par.slice(0, j))
    if (!m.has(k)) m.set(k, dec(j < 0 ? '' : par.slice(j + 1)))
  }
  return m
}

/** ¿Casa este patrón con esta dirección? `consulta` = Map de sus parámetros (?a=b). */
export function casa(patron, ruta, consulta) {
  const { tramos, condiciones } = partir(patron)
  const de = String(ruta || '').split('?')[0].split('/').filter(Boolean)
  if (de.length !== tramos.length) return false
  for (let i = 0; i < tramos.length; i++) {
    if (tramos[i].startsWith(':')) { if (!de[i]) return false; continue }
    if (tramos[i] !== de[i]) return false
  }
  const q = consulta instanceof Map ? consulta : leerConsulta(consulta)
  for (const [k, v] of condiciones) {
    const tiene = q.has(k) && q.get(k) !== ''
    if (v === '*') { if (!tiene) return false }
    else if (v === '') { if (tiene) return false }
    else if (q.get(k) !== v) return false
  }
  return true
}

/** Lo concreto que es un patrón: un tramo fijo pesa más que uno con parámetro, y un valor exacto más que «que esté». */
export function concrecion(patron) {
  const { tramos, condiciones } = partir(patron)
  let n = 0
  for (const t of tramos) n += t.startsWith(':') ? 1 : 3
  for (const [, v] of condiciones) n += v === '*' || v === '' ? 1 : 2
  return n
}

/**
 * Las lecciones con vídeo de la pantalla de ahora: [{ num, titulo, duracion_seg, en_el_curso }], o [] si no tiene (o si el
 * mapa aún no ha llegado). `datos` = lo que contesta GET /api/formacion/como-se-hace.
 */
export function leccionesDeLaPantalla(datos, ruta, busqueda) {
  if (!datos || !Array.isArray(datos.pantallas)) return []
  const consulta = leerConsulta(busqueda)
  for (const d of Array.isArray(datos.por_defecto) ? datos.por_defecto : []) {
    if (!d || !d.clave) continue
    if ((!consulta.has(d.clave) || consulta.get(d.clave) === '') && casa(d.patron, ruta, consulta)) consulta.set(d.clave, String(d.valor))
  }
  const casan = datos.pantallas
    .map((p, i) => ({ p, i }))
    .filter(({ p }) => p && Array.isArray(p.lecciones) && casa(p.patron, ruta, consulta))
    .sort((a, b) => concrecion(b.p.patron) - concrecion(a.p.patron) || a.i - b.i)
  const vistas = new Set()
  const out = []
  for (const { p } of casan) {
    for (const l of p.lecciones) {
      if (!l || vistas.has(l.num)) continue
      vistas.add(l.num)
      out.push(l)
    }
  }
  return out
}

/** «2 min»: la duración de un vídeo como la dice la Formación (un vídeo de 65 s es «1 min»). */
export function minutos(seg) {
  const s = Number(seg) || 0
  return s > 0 ? Math.max(1, Math.round(s / 60)) + ' min' : ''
}
